import React from 'react';
import {Template} from "../../../../components/template/template.jsx";
import {useLoaderData, useParams} from "react-router";
import {FaExternalLinkAlt} from "react-icons/fa";
import {useQuery} from "@tanstack/react-query";
import bosService from "../../../../services/web/bos-service.js";
import {BoKeys} from "../resources/bo-keys.js";
import {Card} from "../../../../components/card/card.jsx";
import {navigateHook} from "../../../../hooks/use-navigate.js";

const BoLastStatus = () => {
    const {id: idRaw} = useParams();
    const id = idRaw?.replace("-", "/");

    const navigate = navigateHook();

    const loaderData = useLoaderData();

    const {data} = useQuery({
        queryFn: () => bosService.getBoInfo(idRaw),
        queryKey: ["bo-info"],
        enabled: !!idRaw
    });

    const {data: lastStatus, isLoading} = useQuery({
        queryFn: () => bosService.getLastStatus(id),
        queryKey: ["bo-last-status"],
        enabled: !!id
    });

    const {data: statusHistory} = useQuery({
        queryFn: () => bosService.getStatusHistoryByBoWeb(id),
        queryKey: ["bo-statusHistory"],
        enabled: !!id,
        retry: false
    });

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title className={"flex gap-2 items-center"}>
                    {loaderData?.bo_name} {id} ({BoKeys[lastStatus?.status] ?? lastStatus?.status})
                    {
                        !!data?.dispatchId &&
                        <span className={"cursor-pointer"} onClick={() => navigate("/despacho/dispatch/form/" + data?.dispatchId, true)}>
                            <FaExternalLinkAlt size={16}/>
                        </span>
                    }
                </Template.Title>
            </Template.Header>

            <Template.Body>
                 <Card>
                     <Card.Body className={"space-y-4"}>
                         <h2 className={"text-center"}>
                             Último status do {loaderData?.bo_name} {id}
                         </h2>
                         {
                             !!lastStatus &&
                             <table className={"border border-[#ebebeb]"}>
                                 <tbody>
                                 <tr>
                                     <td className={"border-r border-b border-[#ebebeb] w-1/5 px-2 py-1"}><b>Número</b></td>
                                     <td className={"px-2 py-1 w-4/5 border-b border-[#ebebeb]"}>{lastStatus.id}</td>
                                 </tr>
                                 <tr>
                                     <td className={"border-r border-b border-[#ebebeb] w-1/5 px-2 py-1"}><b>Status</b></td>
                                     <td className={"px-2 py-1 w-4/5 border-b border-[#ebebeb]"}>{BoKeys[lastStatus.status]}</td>
                                 </tr>
                                 <tr>
                                     <td className={"border-r border-b border-[#ebebeb] w-1/5 px-2 py-1"}><b>Data/Hora</b></td>
                                     <td className={"px-2 py-1 w-4/5 border-b border-[#ebebeb]"}>{lastStatus.dateTime ?? ""}</td>
                                 </tr>
                                 <tr>
                                     <td className={"border-r border-b border-[#ebebeb] w-1/5 px-2 py-1"}><b>Agente</b></td>
                                     <td className={"px-2 py-1 w-4/5 border-b border-[#ebebeb]"}>{lastStatus.user ?? ""}</td>
                                 </tr>
                                 {lastStatus.phone &&
                                     <tr>
                                         <td className={"border-r border-b border-[#ebebeb] w-1/5 px-2 py-1"}><b>Telefone</b></td>
                                         <td className={"px-2 py-1 w-4/5 border-b border-[#ebebeb]"}>{lastStatus.phone}</td>
                                     </tr>
                                 }
                                 <tr>
                                     <td className={"border-r border-[#ebebeb] w-1/5 px-2 py-1"}><b>Justificativa</b></td>
                                     <td className={"px-2 py-1 w-4/5 border-b border-[#ebebeb]"}>{lastStatus.observation ?? ""}</td>
                                 </tr>
                                 </tbody>
                             </table>
                         }

                         {
                             statusHistory?.history.filter(item => item?.dateTime && item.status === "NUMBER_GENERATED").map((item, index) => (
                                 <p key={"history-" + index}>Numeração gerada por <b>{item?.userName}</b> em <b>{item?.dateTime}</b>
                                 </p>
                             ))
                         }
                     </Card.Body>
                 </Card>
            </Template.Body>
        </Template>
    );
};

export default BoLastStatus;